'use client';
import { lazy, Suspense, forwardRef, useRef, type ComponentProps, type ComponentRef } from 'react';
export type * from "/tmp/build-399/node_modules/@eliadmin/core/src/components/auth/reset-password-form.tsx";

type Props = NonNullable<ComponentProps<typeof import("/tmp/build-399/node_modules/@eliadmin/core/src/components/auth/reset-password-form.tsx").ResetPasswordForm>>;
const Deferred = lazy(() => import("@eliadmin/module-original/resetPasswordForm").then(m => ({ default: m.ResetPasswordForm })));
export function ResetPasswordForm(props: Props) {  return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }

